<template>
  <div class="content-wrapper" v-if="loadingComplete()">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Ajouter un club
        <small>Fiche club</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
        <li class="active">Ajout d'un club</li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <form role="form">
            <div class="row">
              <div class="col-md-6">

                <div class="box box-primary">
                  <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <div class="box-header with-border">
                    <h3 class="box-title">Logo</h3>
                  </div>
                  <div class="box-body">
                    <img
                      class="img-thumbnail"
                      v-if="newClub.logo_base64"
                      width="200"
                      height="200"
                      :src="newClub.logo_base64">
                    <a class="btn btn-primary btn-flat margin " @click="show_upload_logo=!show_upload_logo">Importer
                      logo</a>
                    <my-upload field="img"
                               @crop-success="cropSuccess"
                               @crop-upload-success="cropUploadSuccess"
                               @crop-upload-fail="cropUploadFail"
                               v-model="show_upload_logo"
                               :width="300"
                               :height="300"
                               langType="fr"
                               :noCircle="true"
                               img-format="jpg">
                    </my-upload>
                  </div>
                </div>

                <div class="box box-primary">
                  <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <div class="box-header with-border">
                    <h3 class="box-title">Données administratives</h3>
                  </div>
                  <div class="box-body">
                    <div class="form-group"
                         :class="{'has-error': numclubexist!=null, 'has-success': numLibre==true && numclubexist==null }"
                    >
                      <label for="numero">Numéro de club</label>
                      <!--//TODO Chech si numero du club est libre lorsqu'on le modifie-->
                      <input type="text" class="form-control" id="numClub"
                             name="club[numero_club]"
                             @keyup="checkIfNumeroClubExist()"
                             placeholder="Numéro du club"
                             v-model="newClub.numero_club"
                             v-validate="'required|numeric'"
                             disabled
                      >

                      <span v-if="numclubexist!=null"
                            class="help-block">Ce numéro est déjà pris par le club  {{numclubexist.club}}</span>
                      <span v-if="numLibre==true && numclubexist==null"
                            class="help-block">Ce numéro est valable</span>

                      <span v-show="errors.has('club[numero_club]')"
                            class="help-block">Numéro de club incorrect</span>
                    </div>

                    <div class="form-group">
                      <label for="province">Province</label>
                      <select id="province" class="form-control" name="club[id_province]"
                              v-model="newClub.id_province">
                        <option
                          v-for="province in getProvinces"
                          :value="province.id"
                        > {{province.province}}
                        </option>
                      </select>
                      <!--<span class="help-block">Help block with error</span>-->
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('club[club]') }">
                      <label for="nom">Nom</label>
                      <input type="text" class="form-control" id="nom" name="club[club]"
                             v-validate="'max:255'"
                             placeholder="Nom du club" v-model="newClub.club">
                      <span v-show="errors.has('club[club]')" class="help-block">Le nom du club doit comporter moins de 255 caractères</span>
                    </div>


                    <div class="form-group"
                         :class="{'has-error': errors.has('club[adresse]') }">
                      <label for="adresse">Rue et numéro du siège</label>
                      <textarea class="form-control"
                                rows="3"
                                id="adresse"
                                name="club[adresse]"
                                v-model="newClub.adresse"
                                v-validate="'max:255'"
                                placeholder="Adresse du club...">
                                </textarea>
                      <span v-show="errors.has('club[adresse]')" class="help-block">L'adresse doit comporter moins de 255 caractères</span>
                    </div>

                    <cp-and-ville
                      :cpProp="this.newClub.cp"
                      :villeProp="this.newClub.ville"
                      placeholder_cp="Code postal du club"
                      placeholder_ville="Ville du club"
                      @villeChanged="setVilleClub"
                      @cpChanged="setcpClub"
                    >
                    </cp-and-ville>

                    <div class="form-group" v-if="getPays">
                      <label for="ville">Pays</label>
                      <select class="form-control" name="club[pays]" v-model="newClub.pays">
                        <option value="ZZ">Pays
                          indéterminé
                        </option>
                        <optgroup label="Habituels">
                          <option
                            v-for="pays in getPays.habituels"
                            :value="pays.id"
                          >{{pays.name}}
                          </option>
                        </optgroup>
                        <optgroup label="Autres">
                          <option
                            v-for="pays in getPays.all"
                            :value="pays.id"
                          > {{pays.name}}
                          </option>
                        </optgroup>
                      </select>
                      <!--<span class="help-block">Help block with error</span>-->
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('club[numero_compte]') }">
                      <label for="numcompte">Numéro de compte</label>
                      <input type="text" class="form-control" id="numcompte" name="club[numero_compte]"
                             v-validate="'max:255'"
                             placeholder="Numéro de compte du club" v-model="newClub.numero_compte">
                      <span v-show="errors.has('club[numero_compte]')" class="help-block">Le numéro de compte ne doit pas dépasser les 255 caractères</span>
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('club[site_web]') }">
                      <label for="site_web">Site web</label>
                      <input type="text" class="form-control" id="site_web" name="club[site_web]"
                             v-validate="'url:require_protocol'"
                             placeholder="Site web du club" v-model="newClub.site_web">
                      <span v-show="errors.has('club[site_web]')" class="help-block">L'adresse du site web doit être une URL valide (précédé de http ou https)</span>
                    </div>

                  </div>
                </div>

                <div class="box box-primary">
                  <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <div class="box-header with-border">
                    <h3 class="box-title">Données de contact</h3>
                  </div>
                  <div class="box-body">
                    <div class="form-group" :class="{'has-error': errors.has('club[mail]') }">
                      <label for="mail">E-mail</label>
                      <input type="mail" class="form-control" id="email" name="club[mail]"
                             v-validate="'email'"
                             placeholder="Email du club"
                             v-model="newClub.mail"
                      >
                      <span v-show="errors.has('club[mail]')"
                            class="help-block">Adresse mail incorrecte</span>
                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('club[tel]') }">
                      <label for="telephone">Téléphone</label>
                      <input type="text" class="form-control" id="telephone" name="club[tel]"
                             placeholder="Téléphone du club"
                             v-model="newClub.tel"
                      >
                      <span v-show="errors.has('club[tel]')" class="help-block">Numéro de téléphone incorrect</span>
                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('club[gsm]') }">
                      <label for="gsm">GSM</label>
                      <input type="text" class="form-control" id="gsm" name="club[gsm]"
                             placeholder="GSM du club"
                             v-model="newClub.gsm"
                      >
                      <span v-show="errors.has('club[gsm]')"
                            class="help-block">Numéro de GSM incorrect</span>
                    </div>

                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="box box-primary">
                  <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <div class="box-header with-border">
                    <h3 class="box-title">Données supplémentaires</h3>
                  </div>
                  <div class="box-body">
                    <div class="col-md-6">
                      <div class="form-group">

                        <div class="checkbox">
                          <label for="adeps">
                            <input id="adeps" name="club[adeps]" type="checkbox"
                                   v-model="newClub.adeps">
                            Club ADEPS
                          </label>
                        </div>
                        <div class="checkbox">
                          <label for="scolaire">
                            <input id="scolaire" name="club[club_scolaire]" type="checkbox"
                                   v-model="newClub.club_scolaire">
                            Club scolaire
                          </label>
                        </div>
                        <div class="checkbox">
                          <label for="cours_enfant">
                            <input id="cours_enfant" name="club[cours_enfant]" type="checkbox"
                                   v-model="newClub.cours_enfant">
                            Propose des cours pour enfants
                          </label>
                        </div>

                        <div class="checkbox">
                          <label for="fbft">
                            <input id="fbft" name="club[fbft]" type="checkbox"
                                   v-model="newClub.fbft">
                            Club FBFT
                          </label>
                        </div>

                        <div class="checkbox">
                          <label for="ubft">
                            <input id="ubft" name="club[ubft]" type="checkbox"
                                   v-model="newClub.ubft">
                            Club UBFT
                          </label>
                        </div>

                      </div>

                    </div>
                    <div class="col-md-6">
                      <div class="radio">
                        <label for="taekwondo">
                          <input id="taekwondo" name="club[type]" value="taekwondo" type="radio"
                                 v-model="typeClub">
                          Club Taekwondo
                        </label>
                      </div>

                      <div class="radio">
                        <label for="tangsoodo">
                          <input id="tangsoodo" name="club[type]" value="tangsoodo" type="radio"
                                 v-model="typeClub">
                          Club Tangsoodo
                        </label>
                      </div>

                      <div class="radio">
                        <label for="hapkido">
                          <input id="hapkido" name="club[type]" value="hapkido" type="radio"
                                 v-model="typeClub">
                          Club Hapkido
                        </label>
                      </div>
                      <div class="radio">
                        <label for="haedong">
                          <input id="haedong" name="club[type]" value="haedong" type="radio"
                                 v-model="typeClub">
                          Club Haedong Kumdo
                        </label>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="box box-primary">
                  <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <div class="box-header with-border">
                    <h3 class="box-title">Affichage</h3>
                  </div>
                  <div class="box-body">
                    <div>
                      <label for="radiowww">Site Web </label>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[affichage_site]'" value="1"
                                 v-model="newClub.affichage_site">
                          Afficher sur https://www.abft.be
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[affichage_site]'" value="0"
                                 v-model="newClub.affichage_site">
                          Ne pas afficher sur le site
                        </label>
                      </div>
                    </div>

                    <div>
                      <label for="radiowww">Ranking</label>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[affichage_ranking]'" value="1"
                                 v-model="newClub.affichage_ranking">
                          Afficher sur le ranking
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[affichage_ranking]'" value="0"
                                 v-model="newClub.affichage_ranking">
                          Ne pas afficher sur le ranking
                        </label>
                      </div>
                    </div>

                    <div>
                      <label for="radiowww">Correspondant</label>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[affichage_correspondant]'" value="1"
                                 v-model="newClub.affichage_correspondant">
                          Afficher les coordonnées du correspondant
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[affichage_correspondant]'" value="0"
                                 v-model="newClub.affichage_correspondant">
                          Afficher les coordonnées de cette fiche
                        </label>
                      </div>
                    </div>

                    <div>
                      <label for="radiowww">Adresse du club</label>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[affichage_adresse_siege_club]'" value="1"
                                 v-model="newClub.affichage_adresse_siege_club">
                          Afficher l'adresse du siège du club
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[affichage_adresse_siege_club]'" value="0"
                                 v-model="newClub.affichage_adresse_siege_club">
                          Masquer l'adresse du siège du club
                        </label>
                      </div>
                    </div>

                    <div>
                      <label for="radiowww">Expédition</label>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[adresse_expedition]'" :value="0"
                                 v-model="newClub.adresse_expedition">
                          Utiliser l'affichage classique
                          <ul>
                            <li>Nom du club</li>
                            <li>Nom du correspondant</li>
                            <li>Adresse du correspondant</li>
                            <li>Ville du correpsondant</li>
                          </ul>
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio" :name="'newClub[choix_adresse_expedition]'" :value="1"
                                 v-model="choix_adresse_expedition">
                          Utiliser une adresse personnalisée
                          <p>
                    <textarea
                      v-show="choix_adresse_expedition"
                      v-model="newClub.adresse_expedition"
                      style="width: 400px; min-height: 250px" row="10" cols="10">

                    </textarea>
                          </p>
                        </label>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="box">
                  <div class="overlay"
                       v-if="this.disabledBtn"
                  >
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <div class="box-body">
                  </div>
                  <div class="box-footer">
                    <button type="button"
                            class="btn btn-lg btn-primary btn-flat margin pull-right"
                            :disabled="errors.count()!=0 || !this.numLibre || this.disabledBtn || this.loadingInputs.length>0"
                            @click="sendForm()"
                    >
                      Ajouter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import Datepicker from 'vuejs-datepicker';
    import ListSelectClub from '../../Communs/listeSelectClub'
    import cpAndVille from '../../Communs/cpAndVille'
    import vSelect from '../../Communs/vSelect/index'
    import cropUpload from '../../Communs/ImgCropUpload'

    var $ = require('jquery');
    var variables = require('../../../assets/js/variables')
    var _ = require('underscore')
    var moment = require('moment')
    var FileSaver = require('file-saver');

    export default {
        data() {
            return {
                newClub: null,
                numLicenceExist: null,
                show_upload_logo: false,
                villeTemp: null,
                numclubexist: null,
                numLibre: true,
                loadingInputs: [],
                disabledBtn: false,
                resize: false,
                redraw: "",
                choix_adresse_expedition: 0,
                loading: false,
                typeClub: 'taekwondo'
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getRoutes: 'getRoutes',
                getVilles: 'getVilles',
                getPays: 'getPays',
                getProvinces: 'getProvinces',
            }),
        },
        mounted: function () {
            var these = this
            this.$nextTick(function () {
                this.loadProvinces()
            })
        },
        created() {
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.resetNewClub();
                vm.getNewNumeroClub()
            })
        },
        components: {
            cpAndVille,
            ListSelectClub,
            vSelect,
            'my-upload': cropUpload
        },
        methods: {
            ...mapActions({
                setMember: 'setMember',
                setProvinces: 'setProvinces',
            }),
            loadProvinces: function () {
                this.$http.get(this.getRoute('getAllProvinces')).then((response) => {
                    this.setProvinces(response.body)
                }, (response) => {
                });
            },
            cropSuccess(imgDataUrl, field) {
                this.newClub.logo_base64 = imgDataUrl;
            },
            cropUploadSuccess(jsonData, field) {
            },
            cropUploadFail(status, field) {
            },
            loadingComplete: function () {
                return this.newClub != null
            },
            resetNewClub: function () {
                this.typeClub = 'taekwondo'
                this.choix_adresse_expedition= 0
                this.newClub = {
                    numero_club: null,
                    club: null,
                    id_province: 8,
                    numero_compte: null,
                    site_web: null,
                    adresse: null,
                    cp: null,
                    ville: null,
                    pays: 'BE',
                    tel: null,
                    mail: null,
                    gsm: null,
                    affichage_correspondant: 0,
                    affichage_adresse_siege_club: 0,
                    affichage_site: 1,
                    affichage_ranking: 1,
                    adresse_expedition: 0,
                    adeps: 1,
                    club_scolaire: 0,
                    cours_enfant: 0,
                    taekwondo: 1,
                    tangsoodo: 0,
                    hapkido: 0,
                    haedong: 0,
                    fbft: 0,
                    ubft: 0,
                    dojangs: null,
                    logo: null,
                    logo_base64: null,
                }
            },
            setVilleClub: function (value) {
                this.newClub.ville = value;
            },
            setcpClub: function (value) {
                this.newClub.cp = value;
            },

            sendForm: function () {
                this.disabledBtn = true;
                this.loading = true;
                let self = this;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        self.$http.post(this.getRoute('Secretariat.club.store'), this.constructFormClub()).then(function (response) {
                            self.$noty.success("Le club a bien été ajouté")
                            self.disabledBtn = false
                            self.loading = false
                            self.$router.push({name: 'Club', params: {club_id: response.body.id}})
                        }, (response) => {
                            self.$noty.error("Erreur dans l'ajout du club")
                            self.disabledBtn = false
                            self.loading = false
                        });
                    } else {
                        self.$noty.error("Certains champs sont erronés/incomplets")
                        self.disabledBtn = false
                        self.loading = false
                    }
                });
            },
            constructFormClub: function () {
                return JSON.stringify({
                    "numero_club": this.newClub.numero_club,
                    "club": this.newClub.club,
                    "id_province": this.newClub.id_province,
                    "numero_compte": this.newClub.numero_compte,
                    "site_web": this.newClub.site_web,
                    "adresse": this.newClub.adresse,
                    "cp": this.newClub.cp,
                    "ville": this.newClub.ville,
                    "pays": this.newClub.pays,
                    "tel": this.newClub.tel,
                    "mail": this.newClub.mail,
                    "gsm": this.newClub.gsm,
                    "affichage_correspondant": this.newClub.affichage_correspondant,
                    "affichage_adresse_siege_club": this.newClub.affichage_adresse_siege_club,
                    "affichage_site": this.newClub.affichage_site,
                    "affichage_ranking": this.newClub.affichage_ranking,
                    "adresse_expedition": this.choix_adresse_expedition ? this.newClub.adresse_expedition : "",
                    "adeps": this.newClub.adeps,
                    "club_scolaire": this.newClub.club_scolaire,
                    "cours_enfant": this.newClub.cours_enfant,
                    "taekwondo": this.typeClub == 'taekwondo' ? 1 : 0,
                    "tangsoodo": this.typeClub == 'tangsoodo' ? 1 : 0,
                    "hapkido": this.typeClub == 'hapkido' ? 1 : 0,
                    "haedong": this.typeClub == 'haedong' ? 1 : 0,
                    "fbft": this.newClub.fbft,
                    "ubft": this.newClub.ubft,
                    "logo": this.newClub.logo,
                    "comite": this.newClub.comite,
                    "logo_base64": this.newClub.logo_base64,
                })
            },
            isInputLoading: function (input) {
                return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
//                _.find(this.loadingInputs, function (inputNames) {
//                    return inputNames.id == input;
//                })
            },
            addToLoadingInputs: function (input) {
                this.loadingInputs.push(input)
            },
            removeFromLoadingInputs: function (input) {
                this.loadingInputs = _.without(this.loadingInputs, input)
            },
            getNewNumeroClub: function () {
                this.addToLoadingInputs('numClub')
                this.$http.get(this.getRoute('getNewNumeroClub')).then((response) => {
                    this.newClub.numero_club = response.body
                    this.removeFromLoadingInputs('numClub')
                }, (response) => {
                });
            },
            show_select_ville: function () {
                return _.isArray(this.getMember.ville) && this.getMember.ville.length > 1
            },
            villeByCp: function (cp) {
                var result = _.filter(this.getVilles, function (item) {
                    return item.cp == cp;
                });
                if (result.length == 0)
                    return this.getMember.ville = ""
                if (result.length == 1)
                    return this.getMember.ville = result[0].name

                this.getMember.ville = result
            },
            formatDate: function (value, fmt) {
                if (value == null) return ''
                fmt = (typeof fmt == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmt
                return moment(value, 'YYYY-MM-DD hh:mm:ss').format(fmt)
            },
        },
        watch: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/AddNewClub.vue